import { Circle, CircleMarker, MapContainer, TileLayer } from "react-leaflet";

interface Ev { latitude?: number | null; longitude?: number | null; accuracy_m?: number | null; outcome?: string }

export function EvidenceMap({ venue, evidence, purged }: { venue: { latitude: number; longitude: number; geofence_radius_feet: number } | null; evidence: Ev[]; purged: boolean }) {
  const pts = evidence.filter((e) => e.latitude != null && e.longitude != null);
  if (purged) return <p data-testid="evidence-purged" className="rounded-sm border border-white/10 p-4 text-xs text-zinc-400">Precise location purged per retention policy. The pass/fail result is still kept on the punch request.</p>;
  if (!venue || pts.length === 0) return <p data-testid="evidence-map-empty" className="text-xs text-zinc-500">No location was submitted for this item.</p>;
  return (
    <div data-testid="evidence-map" className="h-64 overflow-hidden rounded-sm border border-white/10">
      <MapContainer center={[venue.latitude, venue.longitude]} zoom={15} className="h-full w-full" scrollWheelZoom={false}>
        <TileLayer className="map-tiles-dark" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
        <Circle center={[venue.latitude, venue.longitude]} radius={venue.geofence_radius_feet * 0.3048} pathOptions={{ color: "#ff1d00", weight: 2, fillOpacity: 0.1 }} />
        {pts.map((p, i) => (
          <div key={i}>
            <Circle center={[p.latitude!, p.longitude!]} radius={p.accuracy_m ?? 0} pathOptions={{ color: p.outcome === "PASS" ? "#34d399" : "#fbbf24", weight: 1, fillOpacity: 0.15 }} />
            <CircleMarker center={[p.latitude!, p.longitude!]} radius={5} pathOptions={{ color: "#fff", fillColor: p.outcome === "PASS" ? "#34d399" : "#fbbf24", fillOpacity: 1 }} />
          </div>
        ))}
      </MapContainer>
    </div>
  );
}
